var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SfCarousel',{staticClass:"carousel",attrs:{"settings":{
    type: 'carousel',
    rewind: false,
    perView: 1,
    autoplay: 5000,
    hoverpause: true,
    gap: 0,
    breakpoints: { 1023: { perView: 1 } },
  }}},_vm._l((_vm.topbarData),function(data){return _c('SfCarouselItem',{key:data.topbar_id},[_c('div',{staticClass:"sf-carousel__item_container",staticStyle:{"margin":"0 4px"}},[_c('SfLink',{staticClass:"top-link",attrs:{"link":data.link || ''}},[_c('p',[_vm._v(_vm._s(data.content)+":")])]),_vm._v(" "),_c('SfButton',{ref:"copyButton",refInFor:true,staticClass:"topbar__button sf-button--text",staticStyle:{"width":"100px"},on:{"click":function($event){return _vm.onCopy(data.coupon)}}},[_vm._v("\n        "+_vm._s(data.coupon)+"\n      ")])],1)])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }